import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { orgActions } from "../../actions";
import { Link } from "react-router-dom";

function OrgUsers(props) {
  const { authentication, org, getOrgUsers, getOrgDetail } = props;
  const org_detail = org.org_detail;
  const current_org_id = org.current_org_id;
  const org_id = props.match.params.id;
  const org_users = org.org_users;

  useEffect(() => {
    getOrgUsers(org_id);
    getOrgDetail(org_id);
  }, [org_id])

  const current_org_users = [];
  const current_org_inactive_users = [];
  const ancestor_org_users = [];
  const ancestor_org_inactive_users = [];
  const tagtech_users = [];

  if (org_users && current_org_id) {
    for (const user of org_users) {
      if (user.org_id === current_org_id) {
        if (user.active) {
          current_org_users.push(user);
        } else {
          current_org_inactive_users.push(user);
        }
        
      } else if (user.org_id === 1) { // the tag tech org id
        tagtech_users.push(user);
      } else {
        if (user.active) {
          ancestor_org_users.push(user);
        } else {
          ancestor_org_inactive_users.push(user);
        }
      }
    }
  }

  const headers = ["Email", "Org"];
  const tableHeaders = headers.map((header, i) => <th>{header}</th>);

  function mapUserArrayToTableRows(users) {
    const output = users.length === 0 ? null :
      users.map((user, i) => (
        <>
          <tr>
            <td>
              <Link
                to={{
                  pathname: "/user/" + user.user_id,
                  state: { user_to_edit: user },
                }}
              >
                {user.email}
              </Link>
            </td>
            <td>{user.org_name}</td>
          </tr>
        </>
      ));

    return output;
  }


  return (
    <div class="searchMain">
      <h3>{org_detail?.display_name}</h3>

      <table className="paleBlueRows narrow">
        <tbody>
          <tr>
            <th className="singleTableHeader" colspan="2">
              Active users created on this Org
            </th>
          </tr>
          {mapUserArrayToTableRows(current_org_users)}
        </tbody>
      </table>
      <br /><br/>

      {current_org_inactive_users?.length > 0 && 
      <>
            <table className="paleBlueRows narrow">
            <tbody>
              <tr>
                <th className="singleTableHeader" colspan="2">
                  Deactivated users created on this Org
                </th>
              </tr>
              {mapUserArrayToTableRows(current_org_inactive_users)}
            </tbody>
          </table>      
          <br /><br />
          </>
      }

    {current_org_inactive_users?.length === 0 && 
      <>
            <table className="paleBlueRows narrow">
            <tbody>
              <tr>
                <th className="singleTableHeader" colspan="2">
                  No deactivated users on this Org
                </th>
              </tr>
            </tbody>
          </table>      
          <br /><br />
          </>
      }      


      {ancestor_org_users.length > 0 && (
        <>
          <table className="paleBlueRows narrow">
            <tbody>
              <tr>
                <th className="singleTableHeader" colspan="2">
                  Active users from ancestor Orgs
                </th>
              </tr>
              {mapUserArrayToTableRows(ancestor_org_users)}
            </tbody>
          </table>
          <br /><br />
        </>
      )}

      {ancestor_org_users.length === 0 &&
      <>
            <table className="paleBlueRows narrow">
            <tbody>
              <tr>
                <th className="singleTableHeader" colspan="2">
                  No active users from ancestor Orgs
                </th>
              </tr>
            </tbody>
          </table>      
          <br /><br />      
      </>
      }

      {ancestor_org_inactive_users.length > 0 && (
        <>
          <table className="paleBlueRows narrow">
            <tbody>
              <tr>
                <th className="singleTableHeader" colspan="2">
                  Deactivated users from ancestor Orgs
                </th>
              </tr>
              {mapUserArrayToTableRows(ancestor_org_inactive_users)}
            </tbody>
          </table>
          <br /><br />
        </>
      )}      

    {ancestor_org_inactive_users.length === 0 &&
      <>
            <table className="paleBlueRows narrow">
            <tbody>
              <tr>
                <th className="singleTableHeader" colspan="2">
                  No deactivated users from ancestor Orgs
                </th>
              </tr>
            </tbody>
          </table>      
          <br /><br />      
      </>
      }      

      {tagtech_users.length > 0 && (
        <>
          <table className="paleBlueRows narrow">
            <tbody>
              <tr>
                <th className="singleTableHeader" colspan="2">
                  Tag Tech users
                </th>
              </tr>
              {mapUserArrayToTableRows(tagtech_users)}
            </tbody>
          </table>
          <br /><br />

        </>
      )}
    </div>
  );
}

function mapStateToProps(state) {
  const { authentication, org } = state;
  return {
    authentication,
    org,
  };
}

const actionCreators = {
  getOrgUsers: orgActions.getOrgUsers,
  getOrgDetail: orgActions.getOrgDetail
};

const connectedOrgUsers = connect(mapStateToProps, actionCreators)(OrgUsers);
export { connectedOrgUsers as OrgUsers };
